'use strict';

var _toArray2 = require('babel-runtime/helpers/toArray');

var _toArray3 = _interopRequireDefault(_toArray2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _log = require('babel-runtime/core-js/math/log10');

var _log2 = _interopRequireDefault(_log);

var _tone = require('tone');

var _tone2 = _interopRequireDefault(_tone);

var _nexusui = require('nexusui');

var _nexusui2 = _interopRequireDefault(_nexusui);

var _keys = require('./lib/keys');

var _keys2 = _interopRequireDefault(_keys);

var _scales = require('./lib/scales');

var _scales2 = _interopRequireDefault(_scales);

var _kalimba = require('./lib/kalimba');

var _kalimba2 = _interopRequireDefault(_kalimba);

var _midi = require('./lib/midi');

var _util = require('./lib/util');

var _ui = require('./lib/ui');

var _data = require('./data');

var data = _interopRequireWildcard(_data);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_BPM = 60;

var recorder = null;
var recording = false;
var paused = false;
var playTimeout = void 0;

(0, _midi.midi_init)();

/* initialization */

var mass_fields = ["date", "timestamp", "fatalities", "injured", "total_victims", "age", "case", "weapon_type", "weapon_details"].reduce(function (a, b, i) {
  a[b] = i;
  return a;
}, {});

var gv_fields = ["incident_id", "date", "state", "city_or_county", "address", "n_killed", "n_injured", "incident_url", "source_url", "incident_url_fields_missing", "congressional_district", "gun_stolen", "gun_type", "incident_characteristics", "latitude", "location_description", "longitude", "n_guns_involved", "notes", "participant_age", "participant_age_group", "participant_gender", "participant_name", "participant_relationship", "participant_status", "participant_type", "sources", "state_house_district", "state_senate_district"].reduce(function (a, b, i) {
  a[b] = i;
  return a;
}, {});

var year_days_by_month = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31, 0].reduce(function (a, b, i) {
  if (i === 0) {
    return [b];
  }
  return a.concat(a[i - 1] + b);
}, []);

var i = 0,
    max_i = 0,
    mass_i = 0;
var datasets = {},
    dataset = {},
    bounds = {},
    diff = [];
var play_fn = _midi.play_sequence;
data.load().then(function (lists) {
  console.log(lists);

  var fmedia = lists.media;
  var mediaLines = [];
  for (var i = 0; i < fmedia.lines.length; i++) {
    mediaLines.push(fmedia.lines[i]);
    // if ((i % 7) == 6) {
    //   mediaLines.push([i, 0, 0])
    // }
  }
  datasets['Media'] = {};
  datasets['Media'].name = 'Media after Parkland';
  datasets['Media'].play_fn = _midi.play_sequence;
  datasets['Media'].h = fmedia.h.slice(1, 5);
  datasets['Media'].labels = mediaLines.map(function (l) {
    return l.slice(0, 1).map(function (n) {
      return (n / 7).toFixed(1);
    });
  });
  datasets['Media'].lines = mediaLines.map(function (l) {
    return l.slice(1, 3).map(function (n) {
      return (0, _log2.default)(n + 1);
    });
  });
  datasets['Media'].onPick = function () {
    _ui.nx.offset.value = -13;
    _ui.nx.multiply.value = 20;
    document.querySelector('#scale').value = '0';
    _scales2.default.pick(0);
  };

  var ar15 = lists.ar_15_2016_18;
  datasets['AR-15 2016-18'] = {};
  datasets['AR-15 2016-18'].name = 'AR-15 (2016-18)';
  datasets['AR-15 2016-18'].pedal = true;
  datasets['AR-15 2016-18'].play_fn = play_mass_shootings;
  var ar_lines = ar15.lines.map(function (l) {
    if (l[gv_fields.incident_characteristics].match('Shots Fired - No Injuries')) {
      return null;
    }
    if (l[gv_fields.n_killed] + l[gv_fields.n_injured] < 4) return null;

    var _l$gv_fields$date$spl = l[gv_fields.date].split('-'),
        _l$gv_fields$date$spl2 = (0, _slicedToArray3.default)(_l$gv_fields$date$spl, 3),
        y = _l$gv_fields$date$spl2[0],
        m = _l$gv_fields$date$spl2[1],
        d = _l$gv_fields$date$spl2[2];

    if (parseInt(y) > 2017) return null;
    var yy = (parseInt(y) - 2016) * 365;
    var mm = year_days_by_month[parseInt(m)];
    var dd = Math.floor(parseInt(d)) + 14;
    var date = Math.floor((yy + mm + dd) / 7);
    // console.log(date, y, m, d)
    var total = l[gv_fields.n_killed] + l[gv_fields.n_injured];
    if (l[gv_fields.n_killed] === 0) {
      total = -l[gv_fields.n_injured];
    }
    return [date, Math.log(Math.log(total + 10) + 1), "** !!, $$, {} killed, [] injured".replace('**', l[gv_fields.date]).replace('!!', l[gv_fields.city_or_county]).replace('$$', l[gv_fields.state]).replace('{}', l[gv_fields.n_killed]).replace('[]', l[gv_fields.n_injured]), l[gv_fields.n_killed], l[gv_fields.n_injured]];
  }).filter(function (n) {
    return !!n;
  });
  datasets['AR-15 2016-18'].dates = ar_lines.map(function (a) {
    return a[0];
  });
  datasets['AR-15 2016-18'].dates.push(ar_lines.length);
  datasets['AR-15 2016-18'].lines = [ar_lines.map(function (a) {
    return a[1];
  })];
  datasets['AR-15 2016-18'].labels = ar_lines.map(function (a) {
    return a[2];
  });

  var schools = lists.school_shootings;
  datasets['School Shootings 2015-18'] = {};
  datasets['School Shootings 2015-18'].name = 'School Shootings (2015-18)';
  datasets['School Shootings 2015-18'].pedal = true;
  datasets['School Shootings 2015-18'].play_fn = play_mass_shootings;
  datasets['School Shootings 2015-18'].onPick = function () {
    _ui.nx.offset.value = -2;
    _ui.nx.multiply.value = 11;
    _ui.nx.pedal_tone.value = -8;
    document.querySelector('#scale').value = '0';
    _scales2.default.pick(0);
  };
  var school_lines = schools.lines.map(function (l) {
    if (l[gv_fields.incident_characteristics].match('Shots Fired - No Injuries')) {
      return null;
    }
    if (l[gv_fields.n_killed] + l[gv_fields.n_injured] < 4) return null;

    var _l$gv_fields$date$spl3 = l[gv_fields.date].split('-'),
        _l$gv_fields$date$spl4 = (0, _slicedToArray3.default)(_l$gv_fields$date$spl3, 3),
        y = _l$gv_fields$date$spl4[0],
        m = _l$gv_fields$date$spl4[1],
        d = _l$gv_fields$date$spl4[2];

    if (parseInt(y) > 2018) return null;
    if (parseInt(y) < 2015) return null;
    var yy = (parseInt(y) - 2015) * 365;
    var mm = year_days_by_month[parseInt(m)];
    var dd = Math.floor(parseInt(d)) + 14;
    var date = Math.floor((yy + mm + dd) / 7);
    // console.log(date, y, m, d)
    var total = l[gv_fields.n_killed] + l[gv_fields.n_injured];
    if (l[gv_fields.n_killed] === 0) {
      total = l[gv_fields.n_injured] - 4;
    }
    return [date, Math.log(Math.log(total + 10) + 1), "** !!, $$, {} killed, [] injured".replace('**', l[gv_fields.date]).replace('!!', l[gv_fields.city_or_county]).replace('$$', l[gv_fields.state]).replace('{}', l[gv_fields.n_killed]).replace('[]', l[gv_fields.n_injured]), l[gv_fields.n_killed], l[gv_fields.n_injured]];
  }).filter(function (n) {
    return !!n;
  });
  datasets['School Shootings 2015-18'].dates = school_lines.map(function (a) {
    return a[0];
  });
  datasets['School Shootings 2015-18'].dates.push(school_lines.length);
  datasets['School Shootings 2015-18'].lines = [school_lines.map(function (a) {
    return a[1];
  })];
  datasets['School Shootings 2015-18'].labels = school_lines.map(function (a) {
    return a[2];
  });

  var fm = lists.firearms_manufactured;
  datasets['Firearms Manufactured'] = {};
  datasets['Firearms Manufactured'].name = 'Firearms Manufactured';
  datasets['Firearms Manufactured'].play_fn = _midi.play_sequence;
  datasets['Firearms Manufactured'].h = fm.h.slice(1, 5);
  datasets['Firearms Manufactured'].labels = fm.lines.map(function (l) {
    return l.slice(0, 1);
  });
  datasets['Firearms Manufactured'].lines = fm.lines.map(function (l) {
    return l.slice(1, 5);
  });
  (0, _util.transpose)(lists.gun_violence_by_month.lines).forEach(function (row, i) {
    var name = lists.gun_violence_by_month.h[i];
    if (name === 'Date') return;
    // console.log(name, row)
    datasets[name] = {
      name: name,
      h: [name],
      lines: [row.map(function (n) {
        return parseInt(n);
      })],
      play_fn: _midi.play_sequence
    };
  });
  datasets["Mass Shootings"] = lists.mass_shootings_from_columbine;
  datasets["Mass Shootings"].name = "Mass Shootings";
  datasets["Mass Shootings"].pedal = true;
  datasets["Mass Shootings"].isMass = true;
  datasets["Mass Shootings"].play_fn = play_mass_shootings;
  var lines = datasets["Mass Shootings"].lines.reverse();

  var _lines$0$mass_fields$ = lines[0][mass_fields.date].split('/'),
      _lines$0$mass_fields$2 = (0, _toArray3.default)(_lines$0$mass_fields$),
      min_y = _lines$0$mass_fields$2[0],
      rest_a = _lines$0$mass_fields$2.slice(1);

  var _lines$mass_fields$da = lines[lines.length - 1][mass_fields.date].split('/'),
      _lines$mass_fields$da2 = (0, _toArray3.default)(_lines$mass_fields$da),
      max_y = _lines$mass_fields$da2[0],
      rest_b = _lines$mass_fields$da2.slice(1);

  datasets["Mass Shootings"].dates = lines.map(function (row) {
    var _row$mass_fields$date = row[mass_fields.date].split('/'),
        _row$mass_fields$date2 = (0, _slicedToArray3.default)(_row$mass_fields$date, 3),
        y = _row$mass_fields$date2[0],
        m = _row$mass_fields$date2[1],
        d = _row$mass_fields$date2[2];

    return (parseInt(y) - parseInt(min_y)) * 12 + parseInt(m);
  });
  datasets["Mass Shootings"].max_i = (parseInt(max_y) - parseInt(min_y)) * 12 + parseInt(12);
  // console.log('max i', max_i)
  datasets["Mass Shootings"].data = lines;
  datasets["Mass Shootings"].lines = [lines.map(function (row) {
    return row[mass_fields.total_victims];
  })];
  (0, _util.requestAudioContext)(ready);
});

/* play function for mass shooting data w/ custom timing */

// export const note_values = [
//   [8, '8 measures', 8 * 512],
//   [4, '4 measures', 4 * 512],
//   [2, '2 measures', 2 * 512],
//   [1, 'whole note', 512],
//   [1/2, 'half note', 256],
//   [1/3, 'third note', [170, 170, 171]],
//   [1/4, 'quarter note', 128],
//   [1/5, 'fifth note', [51,51,51,51,52]],
//   [1/6, 'sixth note', [85, 85, 86, 85, 85, 86]],
//   [1/8, 'eighth note', 64],
//   [1/10, 'tenth note', [25,26,26,25,26,25,26,26,25,26]],
//   [1/12, 'twelfth note', [21,21,22, 21,21,22, 21,21,22, 21,21,22]],
//   [1/16, 'sixteenth note', 32],
//   [1/32, 'thirtysecond note', 16],
// ]

function play_mass_shootings(i, bounds, diff, note_time) {
  var channel = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "all";
  var exporting = arguments[5];
  var min = bounds.min,
      max = bounds.max;

  var total = dataset.dates.length;
  var pedal_note = void 0;
  var notes = [],
      midi_notes = [];
  var cases = [];
  var timings = void 0;
  var week = Math.floor(i / 4) % 4;
  var year = Math.floor((i - 4 * 4 * 3) / 48); // + 2
  console.log(year);
  var yy = -year;
  if (year > 0) year += 1;
  var this_one = 0;
  // console.log(i, mass_i, dataset.dates[mass_i], channel, exporting)
  while (i >= dataset.dates[mass_i] && mass_i < total) {
    // console.log(i, dataset.dates[mass_i])
    notes.push(dataset.lines[0][mass_i]);
    if (dataset.isMass) {
      cases.push(dataset.data[mass_i][mass_fields.date] + ' ' + dataset.data[mass_i][mass_fields.case] + ", " + dataset.data[mass_i][mass_fields.fatalities] + ' dead, ' + dataset.data[mass_i][mass_fields.injured] + ' injured');
    } else {
      cases.push(dataset.labels[mass_i]);
      // console.log(dataset.labels[mass_i])
    }
    // console.log('push case', dataset.data[mass_i][mass_fields.date] + ' ' + dataset.data[mass_i][mass_fields.case])
    mass_i += 1;
    this_one += 1;
    if (this_one >= 4) break;
  }
  switch (notes.length) {
    default:
    case 0:
      break;
    case 1:
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[0], min, max) * _ui.nx.multiply.value + yy, 128, channel, exporting, 0));
      timings = [128];
      break;
    case 2:
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[0], min, max) * _ui.nx.multiply.value + yy, 64, channel, exporting, 0));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[1], min, max) * _ui.nx.multiply.value + yy, 64, channel, exporting, 64));
      timings = [64, 64];
      break;
    case 3:
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[0], min, max) * _ui.nx.multiply.value + yy, 43, channel, exporting, 0));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[1], min, max) * _ui.nx.multiply.value + yy, 43, channel, exporting, 43));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[2], min, max) * _ui.nx.multiply.value + yy, 42, channel, exporting, 85));
      timings = [43, 43, 42];
      break;
    case 4:
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[0], min, max) * _ui.nx.multiply.value + yy, 32, channel, exporting, 0));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[1], min, max) * _ui.nx.multiply.value + yy, 32, channel, exporting, 32));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[2], min, max) * _ui.nx.multiply.value + yy, 32, channel, exporting, 64));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[3], min, max) * _ui.nx.multiply.value + yy, 32, channel, exporting, 96));
      timings = [32, 32, 32, 32];
      break;
    case 5:
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[0], min, max) * _ui.nx.multiply.value + yy, 22, channel, exporting, 0));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[1], min, max) * _ui.nx.multiply.value + yy, 21, channel, exporting, 22));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[2], min, max) * _ui.nx.multiply.value + yy, 21, channel, exporting, 43));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[3], min, max) * _ui.nx.multiply.value + yy, 32, channel, exporting, 64));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[4], min, max) * _ui.nx.multiply.value + yy, 32, channel, exporting, 96));
      timings = [22, 21, 21, 32, 32];
      break;
    case 6:
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[0], min, max) * _ui.nx.multiply.value + yy, 22, channel, exporting, 0));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[1], min, max) * _ui.nx.multiply.value + yy, 21, channel, exporting, 22));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[2], min, max) * _ui.nx.multiply.value + yy, 21, channel, exporting, 43));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[3], min, max) * _ui.nx.multiply.value + yy, 22, channel, exporting, 64));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[4], min, max) * _ui.nx.multiply.value + yy, 21, channel, exporting, 86));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[5], min, max) * _ui.nx.multiply.value + yy, 21, channel, exporting, 107));
      timings = [22, 21, 21, 22, 21, 21];
      break;
    case 7:
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[0], min, max) * _ui.nx.multiply.value, 16, channel, exporting, 0));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[1], min, max) * _ui.nx.multiply.value, 16, channel, exporting, 16));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[2], min, max) * _ui.nx.multiply.value, 16, channel, exporting, 32));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[3], min, max) * _ui.nx.multiply.value, 16, channel, exporting, 48));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[4], min, max) * _ui.nx.multiply.value, 22, channel, exporting, 64));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[5], min, max) * _ui.nx.multiply.value, 21, channel, exporting, 86));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[6], min, max) * _ui.nx.multiply.value, 21, channel, exporting, 107));
      timings = [16, 16, 16, 16, 22, 21, 21];
      break;
    case 8:
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[0], min, max) * _ui.nx.multiply.value, 16, channel, exporting, 0));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[1], min, max) * _ui.nx.multiply.value, 16, channel, exporting, 16));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[2], min, max) * _ui.nx.multiply.value, 16, channel, exporting, 32));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[3], min, max) * _ui.nx.multiply.value, 16, channel, exporting, 48));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[4], min, max) * _ui.nx.multiply.value, 16, channel, exporting, 64));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[5], min, max) * _ui.nx.multiply.value, 16, channel, exporting, 80));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[6], min, max) * _ui.nx.multiply.value, 16, channel, exporting, 96));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[7], min, max) * _ui.nx.multiply.value, 16, channel, exporting, 112));
      timings = [16, 16, 16, 16, 16, 16, 16, 16];
      break;
    case 9:
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[0], min, max) * _ui.nx.multiply.value, 11, channel, exporting, 0));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[1], min, max) * _ui.nx.multiply.value, 11, channel, exporting, 11));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[2], min, max) * _ui.nx.multiply.value, 10, channel, exporting, 22));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[3], min, max) * _ui.nx.multiply.value, 16, channel, exporting, 32));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[4], min, max) * _ui.nx.multiply.value, 16, channel, exporting, 48));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[5], min, max) * _ui.nx.multiply.value, 16, channel, exporting, 64));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[6], min, max) * _ui.nx.multiply.value, 16, channel, exporting, 80));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[7], min, max) * _ui.nx.multiply.value, 16, channel, exporting, 96));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[8], min, max) * _ui.nx.multiply.value, 16, channel, exporting, 112));
      timings = [11, 11, 10, 16, 16, 16, 16, 16, 16];
      break;
    case 10:
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[0], min, max) * _ui.nx.multiply.value, 11, channel, exporting, 0));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[1], min, max) * _ui.nx.multiply.value, 11, channel, exporting, 11));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[2], min, max) * _ui.nx.multiply.value, 10, channel, exporting, 22));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[3], min, max) * _ui.nx.multiply.value, 11, channel, exporting, 32));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[4], min, max) * _ui.nx.multiply.value, 11, channel, exporting, 43));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[5], min, max) * _ui.nx.multiply.value, 10, channel, exporting, 54));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[6], min, max) * _ui.nx.multiply.value, 16, channel, exporting, 64));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[7], min, max) * _ui.nx.multiply.value, 16, channel, exporting, 80));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[8], min, max) * _ui.nx.multiply.value, 16, channel, exporting, 96));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[9], min, max) * _ui.nx.multiply.value, 16, channel, exporting, 112));
      timings = [11, 11, 10, 11, 11, 10, 16, 16, 16, 16];
      break;
    case 11:
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[0], min, max) * _ui.nx.multiply.value, 11, channel, exporting, 0));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[1], min, max) * _ui.nx.multiply.value, 11, channel, exporting, 11));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[2], min, max) * _ui.nx.multiply.value, 10, channel, exporting, 22));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[3], min, max) * _ui.nx.multiply.value, 11, channel, exporting, 32));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[4], min, max) * _ui.nx.multiply.value, 11, channel, exporting, 43));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[5], min, max) * _ui.nx.multiply.value, 10, channel, exporting, 54));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[6], min, max) * _ui.nx.multiply.value, 11, channel, exporting, 64));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[7], min, max) * _ui.nx.multiply.value, 11, channel, exporting, 75));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[8], min, max) * _ui.nx.multiply.value, 10, channel, exporting, 86));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[9], min, max) * _ui.nx.multiply.value, 16, channel, exporting, 96));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[10], min, max) * _ui.nx.multiply.value, 16, channel, exporting, 112));
      timings = [11, 11, 10, 11, 11, 10, 11, 11, 10, 16, 16];
      break;
    case 12:
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[0], min, max) * _ui.nx.multiply.value, 11, channel, exporting, 0));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[1], min, max) * _ui.nx.multiply.value, 11, channel, exporting, 11));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[2], min, max) * _ui.nx.multiply.value, 10, channel, exporting, 22));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[3], min, max) * _ui.nx.multiply.value, 11, channel, exporting, 32));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[4], min, max) * _ui.nx.multiply.value, 11, channel, exporting, 43));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[5], min, max) * _ui.nx.multiply.value, 10, channel, exporting, 54));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[6], min, max) * _ui.nx.multiply.value, 11, channel, exporting, 64));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[7], min, max) * _ui.nx.multiply.value, 11, channel, exporting, 75));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[8], min, max) * _ui.nx.multiply.value, 10, channel, exporting, 86));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[9], min, max) * _ui.nx.multiply.value, 11, channel, exporting, 96));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[10], min, max) * _ui.nx.multiply.value, 11, channel, exporting, 107));
      midi_notes.push((0, _midi.play_note)((0, _util.norm)(notes[11], min, max) * _ui.nx.multiply.value, 10, channel, exporting, 118));
      timings = [11, 11, 10, 11, 11, 10, 11, 11, 10, 11, 11, 10];
      break;
  }
  var pedal_freq = _scales2.default.current().index(_ui.nx.pedal_tone.value - week + 4 - year, _ui.nx.octave.value);
  pedal_note = get_midi_note_for_frequency(pedal_freq);
  if (!exporting) {
    _kalimba2.default.play(pedal_freq, -12);
    if (cases.length) {
      document.querySelector('#cases').innerHTML = cases.join('<br>');
    }
  }
  if (total <= mass_i) {
    mass_i = 0;
    i = 0;
  } else {
    i += 1;
  }

  if (notes.length) {
    return [i, midi_notes, timings, pedal_note];
  }
  return [i, [], [], pedal_note];
}

function get_midi_note_for_frequency(freq) {
  var midi_note = (0, _util.ftom)(freq);
  var cents = midi_note % 1;
  if (cents > 0.5) {
    midi_note += 1;
    cents -= 1;
  }
  cents *= 2;
  midi_note = Math.floor(midi_note);
  if (midi_note > 127) return 0;
  var note = _tone2.default.Frequency(Math.floor(midi_note), "midi").toNote();
  // console.log(freq, midi_note, note)
  return note;
}

/* play next note according to sonification */

function play_next() {
  if (paused) return;
  var note_time = 120000 / _tone2.default.Transport.bpm.value * _midi.note_values[_ui.nx.timing.active][0];
  clearTimeout(playTimeout);
  playTimeout = setTimeout(play_next, note_time);

  var _play_fn = play_fn(i, bounds, diff, note_time),
      _play_fn2 = (0, _slicedToArray3.default)(_play_fn, 3),
      new_i = _play_fn2[0],
      notes = _play_fn2[1],
      timings = _play_fn2[2];

  if (dataset.labels) {
    // const j = Math.floor(i / bounds.rows[0].length)
    // document.querySelector('#cases').innerHTML = dataset.labels[j]
  }

  i = new_i;
  if (recording) {
    var timing = _midi.note_values[_ui.nx.timing.active][2];
    if (timing.length) timing = timing[i % timing.length];
    recorder.addEvent(new _midi.MidiWriter.NoteEvent({ pitch: notes, duration: 't' + timing }));
  }
}

function play() {
  i = 0;
  mass_i = 0;
  paused = false;
  play_next();
}
function pause() {
  paused = true;
}

/* bind selects */

function pick_dataset(key) {
  console.log('pick dataset:', key, datasets[key]);
  i = 0;
  mass_i = 0;
  window.location.hash = key;
  dataset = datasets[key];
  bounds = (0, _util.get_bounds)(dataset);
  diff = (0, _util.get_diff_bounds)(bounds.rows);
  play_fn = dataset.play_fn;
  max_i = dataset.max_i || bounds.rows.length * bounds.rows[0].length;
  if (dataset.onPick) {
    dataset.onPick();
  }
}

/* build and bind the UI */

function ready() {
  _scales2.default.build_options(document.querySelector('#scale'));
  (0, _ui.build_options)(document.querySelector('#dataset'), datasets, pick_dataset);

  var dial_size = [50, 50];

  _tone2.default.Transport.bpm.value = DEFAULT_BPM;
  _ui.nx.tempo = new _nexusui2.default.Dial('#tempo', {
    size: dial_size,
    min: 10,
    max: 300,
    step: 1,
    value: DEFAULT_BPM
  });
  (0, _ui.update_value_on_change)(_ui.nx.tempo, '#tempo', true, function (v) {
    return _tone2.default.Transport.bpm.value = v;
  });

  _ui.nx.timing = new _nexusui2.default.RadioButton('#timing', {
    size: [400, 25],
    numberOfButtons: _midi.note_values.length,
    active: 6
  });
  (0, _ui.update_radio_value_on_change)(_ui.nx.timing, '#timing', _midi.note_values);

  _ui.nx.duration = new _nexusui2.default.Dial('#duration', {
    size: dial_size,
    min: 0,
    max: 2,
    step: 0.01,
    value: 0.8
  });
  (0, _ui.update_value_on_change)(_ui.nx.duration, '#duration', false);

  _ui.nx.offset = new _nexusui2.default.Dial('#offset', {
    size: dial_size,
    min: -24,
    max: 24,
    step: 1,
    value: -5
  });
  (0, _ui.update_value_on_change)(_ui.nx.offset, '#offset', true);

  _ui.nx.octave = new _nexusui2.default.Dial('#octave', {
    size: dial_size,
    min: -4,
    max: 4,
    step: 1,
    value: 0
  });
  (0, _ui.update_value_on_change)(_ui.nx.octave, '#octave', true);

  _ui.nx.multiply = new _nexusui2.default.Dial('#multiply', {
    size: dial_size,
    min: -64,
    max: 64,
    step: 1,
    value: 19
  });
  (0, _ui.update_value_on_change)(_ui.nx.multiply, '#multiply', true);

  _ui.nx.interval = new _nexusui2.default.Dial('#interval', {
    size: dial_size,
    min: -64,
    max: 64,
    step: 1,
    value: 10
  });
  (0, _ui.update_value_on_change)(_ui.nx.interval, '#interval', true);

  _ui.nx.pedal_tone = new _nexusui2.default.Dial('#pedal_tone', {
    size: dial_size,
    min: -24,
    max: 24,
    step: 1,
    value: -7
  });
  (0, _ui.update_value_on_change)(_ui.nx.pedal_tone, '#pedal_tone', true);

  var play_button = document.querySelector('#play');
  play_button.addEventListener('click', function () {
    play();
  });

  var pause_button = document.querySelector('#pause');
  pause_button.addEventListener('click', function () {
    pause();
  });

  var export_midi_button = document.querySelector('#export_midi');
  export_midi_button.addEventListener('click', function () {
    (0, _midi.export_pattern_as_midi)(dataset, bounds, diff, _ui.nx.tempo.value, _ui.nx.timing.active, play_fn, max_i);
  });

  var record_midi_button = document.querySelector('#record_midi');
  record_midi_button.addEventListener('click', function () {
    if (recording) {
      record_midi_button.innerHTML = 'Record MIDI';
      document.body.classList.remove('recording');
      recording = false;
      var writer = new _midi.MidiWriter.Writer([recorder]);
      var blob = (0, _util.dataURItoBlob)(writer.dataUri());
      saveAs(blob, 'Recording - ' + dataset.name + '.mid');
    } else {
      record_midi_button.innerHTML = 'Save Recording';
      document.body.classList.add('recording');
      recording = true;
      recorder = new _midi.MidiWriter.Track();
      recorder.setTempo(_ui.nx.tempo.value);
    }
  });

  document.querySelector('.loading').classList.remove('loading');

  document.querySelector('#scale').value = '14';
  _scales2.default.pick(14);

  var initial_dataset = decodeURIComponent(window.location.hash.substr(1)) || 'Mass Shootings';
  document.querySelector('#dataset').value = initial_dataset;
  pick_dataset(initial_dataset);

  // play_next()
}

/* keys */

_keys2.default.listen(function (index) {
  _ui.nx.offset.value = index;
  _ui.nx.offset.update(index);
});


//////////////////
// WEBPACK FOOTER
// ./client/index.js
// module id = 76
// module chunks = 0